import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  serialNo: string;
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let isAuth = this.authService.isAuthenticated();

    //if (!isAuth) {
    //  this.router.navigate(['/pages/login']);
    //}
    //else {
    //  return true;CustomerDeclaration/CustomerDeclaration
    //}
    if (state.url.includes("/WarrantyRegistration/WarrantyRegistration")
      || state.url.includes("/WarrantyCustomerDetails/WarrantyCustomerDetails")
      || state.url.includes("/WarrantyStatus/WarrantyStatus")
      || state.url.includes("/WarrantyStatusView/WarrantyStatusView")
      || state.url.includes("/WarrantyExchanges/WarrantyExchanges")
      || state.url.includes("/CustomerDeclaration/CustomerDeclaration")
      || state.url.includes("/CRM_salesorder/CRM_salesorder")) {
      debugger
      return true;
    }
    if (!isAuth) {

      if (state.url.includes("/QuoteParameter")) {
        const url = state.url;
        const params = url.split('?')[1]; // Get the query string part of the URL
        const keyValuePairs = params.split('&'); // Split the query string into key-value pairs

        let quoteId: string | null = null;
        let customerCode: string | null = null;

        // Iterate over each key-value pair to find QuoteId and CustomerCode
        for (const pair of keyValuePairs) {
          const [key, value] = pair.split('=');
          if (key === 'OpportunityId') {
            quoteId = value;
          } else if (key === 'CustomerCode') {
            customerCode = value;
          }
        }

        //alert(quoteId); alert(customerCode);
        localStorage.setItem("OpportunityId", quoteId == null ? "" : quoteId); // Using nullish coalescing operator (??) to provide a default value if quoteId is null or undefined
        localStorage.setItem("CustomerCode", customerCode == null ? "" : customerCode); // Similarly, storing customerCode in localStorage

        this.router.navigate(['/pages/login']);
      }
      else {
        localStorage.setItem("OpportunityId", "");
        localStorage.setItem("CustomerCode", "");
        this.router.navigate(['/pages/login']);
      }
    }
    else if (state.url.includes("/warranty")) {
      
        debugger
        const parts = state.url.split('=');
        this.serialNo = decodeURIComponent(parts[1]);
        //this.router.navigate(['https://rrcare.rrkabel.com/WarrantyRegistration/WarrantyRegistration'], { queryParams: { SerialNo: parts[1] } });
        this.router.navigate(['/WarrantyRegistration/WarrantyRegistration'], { queryParams: { SerialNo: parts[1] } });
      
    }
    else {
      if (state.url.includes("/QuoteParameter")) {
        const url = state.url;
        const params = url.split('?')[1]; // Get the query string part of the URL
        const keyValuePairs = params.split('&'); // Split the query string into key-value pairs

        let quoteId: string | null = null;
        let RCCode: string | null = null;
        let IsColorChange: number | 0 = 0;

        // Iterate over each key-value pair to find QuoteId and CustomerCode
        for (const pair of keyValuePairs) {
          const [key, value] = pair.split('=');
          if (key === 'OpportunityId') {
            quoteId = value;
          } else if (key === 'RCCode') {
            RCCode = value;
          }
          else if (key === 'IsColorChange') {
            IsColorChange = parseInt(value, 10) || 0;
          }
        }

        localStorage.setItem("OpportunityId", quoteId == null ? "" : quoteId); // Using nullish coalescing operator (??) to provide a default value if quoteId is null or undefined
        localStorage.setItem("RCCode", RCCode == null ? "" : RCCode); // Similarly, storing RC Code in localStorage
        localStorage.setItem("IsColorChange", IsColorChange.toString()); // Similarly, storing Is Color Change in localStorage
        if(quoteId == undefined || quoteId == null)
        {
          quoteId = "";
        }

        if (quoteId != "") { this.router.navigate(['/CRM_salesorder/CRM_salesorder']); }
      }
      else {
        return true;
      }
    }
  }
}
